import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup, Checkbox } from 'react-bootstrap';

const DriverInfo = (props) => {
  return (
    <FormGroup controlId="driverInfo">

      <Col sm={1}>
        <Checkbox
          inline
          onClick={props.handleChangeDriverInfo}
          checked={props.driverInfo}
          name="driverInfo" />
      </Col>
      <Col componentClass={ControlLabel} sm={11}>
        Driver Information
      </Col>
    </FormGroup>
  )
}

DriverInfo.propTypes = {
  driverInfo: PropTypes.bool,
  handleChangeDriverInfo: PropTypes.func
};

export default DriverInfo;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/driverInfo/DriverInfo.js